import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { CommonResponseModel, JobWorkAgainstUnitDto } from "@project-management-system/shared-models";
import { JobWorkApproverDto } from "./jobwork-approver-dto";
import { JobworkAgainstUnitService } from "./job-work-approval-service";



@Controller('job-work-against-unit')
@ApiTags('/job-work-against-unit')
export class JobWorkAgainstUnitController {
    constructor(private service: JobworkAgainstUnitService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/createJobWorkAgainstUnit')
    @ApiBody({ type: JobWorkApproverDto })
    async createJobWorkAgainstUnit(@Body() req?: any): Promise<CommonResponseModel> {
        try {
            return await this.service.createJobWorkAgainstUnit(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/getAllData')
    async getAllData(): Promise<CommonResponseModel> {
        try {
            return await this.service.getAllData();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/updateJobWorkApproval')
    @ApiBody({ type: JobWorkAgainstUnitDto })
    async updateJobWorkApproval(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.service.updateJobWorkApproval(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateJobWorkApproval')
    @ApiBody({ type: JobWorkAgainstUnitDto })
    async activateOrDeactivateJobWorkApproval(@Body() dto: any): Promise<CommonResponseModel> {
        try {
            return await this.service.activateOrDeactivateJobWorkApproval(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }


}